//2024年中小企业数字化转型‘小灯塔’示范企业补助资金

const indexAdmin = () => import('./indexAdmin');
const indexAppl = () => import('./indexAppl');
const edit = () => import('./edit.vue');

export default {
  routes: [
    {
      path: '/smes/service/v2024/indexAppl',
      name: 'smes_service_v2024_index_appl',
      component: indexAppl,
      meta:{public:true}
    },
    {
      path: '/smes/service/v2024/indexAdmin',
      name: 'smes_service_v2024_index_admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/smes/service/v2024/edit',
      name: 'smes_service_v2024_edit',
      component: edit,
      meta: {public: true}
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/smes/service/v2024/router.js